var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ul", { staticClass: "navbar-nav ml-auto mb-2 mb-lg-0" }, [
    _vm.user
      ? _c(
          "li",
          { staticClass: "nav-item dropdown mr-2" },
          [
            _c(
              "router-link",
              {
                staticClass: "nav-link dropdown-toggle",
                attrs: {
                  to: "#",
                  id: "navbar-dropdown-trackps",
                  role: "button",
                  "data-bs-toggle": "dropdown",
                  "aria-expanded": "false",
                },
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.user.nama_pegawai) +
                    "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "ul",
              {
                staticClass: "dropdown-menu dropdown-menu-end",
                attrs: { "aria-labelledby": "navbar-dropdown-trackps" },
              },
              [
                _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "button",
                    {
                      staticClass: "dropdown-item",
                      attrs: { to: "#" },
                      on: { click: _vm.logout },
                    },
                    [
                      _c("i", { staticClass: "fa fa-sign-out" }),
                      _vm._v("\n                    Logout"),
                    ]
                  ),
                ]),
              ]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }